'use client';
import Image from 'next/image';
import React from 'react';

interface UserProfileCardProps {
  firstName?: string;
  lastName?: string;
  companyName?: string;
  companyPhoto?: string;
  hideCompany?: boolean;
}

const UserProfileCard: React.FC<UserProfileCardProps> = ({
  firstName = '',
  lastName = '',
  companyName = '',
  companyPhoto = '',
  hideCompany = false,
}) => {
  const displayName =
    firstName || lastName
      ? `${firstName || ''} ${lastName || ''}`.trim() || 'Your Name'
      : 'Your Name';

  const displayCompany = companyName || 'Your Company';

  return (
    <div className="relative z-10 flex flex-col items-start overflow-visible rounded-[11.7px] border-[0.975px] border-gray-200 bg-gradient-to-b from-white to-[#F0F0F0] shadow-[0_64.35px_18.2px_0_rgba(0,0,0,0.00),0_41.6px_16.25px_0_rgba(0,0,0,0.00),0_23.4px_13.65px_0_rgba(0,0,0,0.02),0_10.4px_10.4px_0_rgba(0,0,0,0.03),0_2.6px_5.85px_0_rgba(0,0,0,0.03)] w-[352.95px] h-[212.55px] p-[23.4px] gap-[31.2px]">
      <div className="inline-flex flex-col justify-start items-start gap-[1px]">
        {!hideCompany && (
          <div className="w-[95px] h-[95px] rounded-[100px] relative overflow-hidden">
            {companyPhoto ? (
              <img
                src={companyPhoto}
                alt="Company"
                className="w-full h-full object-cover rounded-[100px]"
              />
            ) : (
              <div className="w-full h-full bg-[#D9D9D9] rounded-[100px]" />
            )}
          </div>
        )}
        {!hideCompany && (
          <div className="justify-start text-gray-1000 font-geist text-sm font-medium leading-6 tracking-[-0.14px] pt-[5px]">
            {displayCompany}
          </div>
        )}
        <div className="justify-start text-gray-1000 font-geist text-2xl font-medium leading-9 break-words overflow-hidden [overflow-wrap:anywhere]">
          {displayName}
        </div>
        {hideCompany && (
          <div className="absolute bottom-10 right-6">
            <Image
              src="/zeme-colored-svg.svg"
              alt="Zeme Logo"
              width={95}
              height={16}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default UserProfileCard;
